import React from 'react';
import { PrivateRoute } from 'shared/components/PrivateRoute';
import { paths } from 'shared/routing/paths';
import { defineRoute, AppRoute } from './types';
import { lazyNamed } from './lazy';

const LoginPage = lazyNamed(() => import('pages/LoginPage'), 'LoginPage');
const SignupPage = lazyNamed(() => import('pages/SignupPage'), 'SignupPage');
const ResetPasswordPage = lazyNamed(() => import('pages/ResetPasswordPage'), 'ResetPasswordPage');
const NoPermissionsPage = lazyNamed(() => import('pages/NoPermissionsPage'), 'NoPermissionsPage');
const LandingPage = lazyNamed(() => import('pages/LandingPage'), 'LandingPage');
const UnsubscribePage = lazyNamed(() => import('pages/UnsubscribePage'), 'UnsubscribePage');
const TermsPage = lazyNamed(() => import('pages/TermsPage'), 'TermsPage');
const SecurityPage = lazyNamed(() => import('pages/SecurityPage'), 'SecurityPage');
const ChangelogPage = lazyNamed(() => import('pages/ChangelogPage'), 'ChangelogPage');
const PdfPreviewPage = lazyNamed(() => import('pages/PdfPreviewPage'), 'PdfPreviewPage');
const EmailVerificationPage = lazyNamed(() => import('pages/EmailVerificationPage'), 'EmailVerificationPage');
const SupportPage = lazyNamed(() => import('pages/SupportPage'), 'SupportPage');

function publicPage(id: string, path: string, element: React.ReactNode): AppRoute {
  return defineRoute({ id, path, area: 'public', guard: 'public', layout: 'public', kind: 'page' }, { path, element });
}

function privatePage(id: string, path: string, element: React.ReactNode): AppRoute {
  return defineRoute(
    { id, path, area: 'public', guard: 'private', layout: 'public', kind: 'page' },
    {
      path,
      element: <PrivateRoute>{element}</PrivateRoute>,
    },
  );
}

export const PUBLIC_ROUTES: AppRoute[] = [
  publicPage('public.login', paths.public.login, <LoginPage />),
  publicPage('public.welcome', paths.public.welcome, <LandingPage />),
  publicPage('public.signup', paths.public.signup, <SignupPage />),
  publicPage('public.passwordReset', paths.public.passwordReset, <ResetPasswordPage />),
  publicPage('public.noPermissions', paths.public.noPermissions, <NoPermissionsPage />),
  publicPage('public.unsubscribe', '/unsubscribe/:token', <UnsubscribePage />),
  publicPage('public.terms', paths.public.terms, <TermsPage />),
  publicPage('public.privacy', paths.public.privacy, <TermsPage />),
  publicPage('public.security', paths.public.security, <SecurityPage />),
  publicPage('public.expertChangelog', paths.public.expertChangelog, <ChangelogPage />),
  privatePage('public.pdfPreview', paths.public.pdfPreview, <PdfPreviewPage />),
  privatePage('public.emailVerification', paths.public.emailVerification, <EmailVerificationPage />),
  privatePage('public.support', paths.public.support, <SupportPage />),
];
